<template>
    <div class="apprentice-simple-card">
        <div
            class="assignment-result-wrapper"
            v-if="assignmentsIn.length > 0">
            <div class="assignment-results-header">
                <b-form-select
                    class="apprentice-primary-select select-assignment-results"
                    v-model="selectedAssignmentId"
                    :options="assignmentsOptions">
                </b-form-select>
            </div>

            <div
                class="assignment-results"
                v-if="selectedAssignment">
                <design-2021-group-results-part-component
                    v-for="part in parts"
                    :key="part.id"
                    :part-in="part">
                </design-2021-group-results-part-component>
            </div>
        </div>

        <div
            class="not-found with-header"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice assignments">{{$t('portfolio.no_statistics_found')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-results-tab-content-component',
    props: {
        assignmentsIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedAssignmentId: this.assignmentsIn.length > 0 ? this.assignmentsIn[0].id : null,
        };
    },

    computed: {
        assignmentsOptions() {
            let assignments = [
                {
                    text: this.$t('portfolio.results_choose_assignment'),
                    disabled: true,
                    value: null,
                },
            ];

            this.assignmentsIn.forEach((assignment) => {
                assignments.push({
                    text: assignment.name,
                    value: assignment.id,
                });
            });

            if (assignments.length > 1) {
                this.selectedAssignmentId = assignments[1].value;
            }

            return assignments;
        },

        selectedAssignment() {
            return this.assignmentsIn.find((assignment) => assignment.id === this.selectedAssignmentId);
        },
        parts() {
            let parts = [];
            this.selectedAssignment.sub_assignments
                .sort((a, b) => a.order - b.order)
                .forEach((subAssignment) => {
                    subAssignment.pages
                        .sort((a, b) => a.order - b.order)
                        .forEach((page) => {
                            page.parts
                                .sort((a, b) => a.order - b.order)
                                .forEach((part) => {
                                    parts.push(part);
                                });
                        });
                });

            return parts;
        },
    },
};
</script>

<style scoped lang="scss">
.assignment-results {
    .assignment {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'sixty');
        }
    }
}
.assignment-results-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: map-get($grid-gutter-spacing, ' fifteen');
}

::v-deep .standard-list-results,
::v-deep .color-list-results,
::v-deep .check-list-results {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    align-items: center;
    gap: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    ::v-deep .standard-list-results,
    ::v-deep .color-list-results,
    ::v-deep .check-list-results {
        > div {
            width: calc(50% - 15px);
        }
    }

    .select-assignment-results {
        max-width: clamp(150px, 200px, 450px);
    }
}
</style>
